import {
  type ContentfulImage,
  type ContentfulMediaField,
} from './types/contentful'

// Inverts the text from the background
export const invertHex = (hex: string) => {
  return '#'.concat(
    (Number(`0x1${hex}`) ^ 0xffffff).toString(16).substring(1).toUpperCase(),
  )
}

export const getUrlForMedia = (
  content?: ContentfulImage | ContentfulMediaField,
) => {
  if (!content) return undefined

  const imageSrc = content.file.url

  if (!imageSrc) return imageSrc

  if (imageSrc.startsWith('//')) return `https:${imageSrc}`

  return imageSrc
}

const getFieldForLanguage = (key: string, obj: any, language: string) => {
  if (!obj || !obj.fields[key]) {
    return undefined
  }
  return obj.fields[key][language] || obj.fields[key]['en-CA']
}

export const convertObject = (obj: any, language: string) => {
  if (!obj || !obj.fields) {
    return obj
  }
  const objType =
    obj.sys.type === 'Asset' ? 'Asset' : obj.sys.contentType.sys.id

  const result: any = {
    _type: objType,
  }

  for (const key of Object.keys(obj.fields)) {
    const objField = getFieldForLanguage(key, obj, language)

    if (Array.isArray(objField)) {
      result[key] = objField.map((field) => convertObject(field, language))
    } else {
      result[key] = convertObject(objField, language)
    }
  }
  return result
}

export const asyncForEach = async (
  arr: any[],
  callback: (value: any, index: number, array: any[]) => void,
) => {
  for (let i = 0; i < arr.length; i++) {
    await callback(arr[i], i, arr)
  }
}
